import { Link } from "react-router-dom";
import { landingLinks } from "@/config/landingLinks";
import { BrandLockup } from "@/components/brand/BrandLogo";

export function PublicFooter() {
  return (
    <footer className="border-t border-border bg-card">
      <div className="container py-16">
        <div className="grid grid-cols-2 gap-10 lg:grid-cols-[1.1fr_0.9fr_0.8fr_0.8fr]">
          <div className="col-span-2 space-y-4 lg:col-span-1">
            <BrandLockup markClassName="h-10" textClassName="text-base" />
            <p className="max-w-sm text-sm leading-7 text-muted-foreground">
              Nigeria&apos;s property transaction platform for lawyers, agents, and clients who need visibility from intake to closing.
            </p>
          </div>

          <div className="col-span-1">
            <p className="text-sm font-semibold uppercase tracking-[0.18em] text-foreground">Platform</p>
            <div className="mt-4 flex flex-col gap-3 text-sm text-muted-foreground">
              {landingLinks.footer.map((link) => (
                <Link key={link.href} to={link.href} className="transition-colors hover:text-foreground">
                  {link.label}
                </Link>
              ))}
            </div>
          </div>

          <div className="col-span-1">
            <p className="text-sm font-semibold uppercase tracking-[0.18em] text-foreground">Access</p>
            <div className="mt-4 flex flex-col gap-3 text-sm text-muted-foreground">
              <Link to="/login" className="transition-colors hover:text-foreground">Log In</Link>
              <Link to="/signup" className="transition-colors hover:text-foreground">Get Started</Link>
            </div>
          </div>

          <div className="col-span-2 lg:col-span-1">
            <p className="text-sm font-semibold uppercase tracking-[0.18em] text-foreground">Audience</p>
            <div className="mt-4 flex flex-col gap-3 text-sm text-muted-foreground">
              {landingLinks.features.map((feature) => (
                <Link key={feature.label} to={feature.href} className="transition-colors hover:text-foreground">
                  {feature.label}
                </Link>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-12 border-t border-border pt-6 text-xs text-muted-foreground">
          <p>© 2026 GuardOS Technologies. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
